import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { useMedplumProfile } from '@medplum/react';
import { SectionLayout } from './components/SectionLayout';
import { SessionTimeoutGuard } from './components/SessionTimeoutGuard';
import { PortalLayout } from './components/portal/PortalLayout';
import { Dashboard } from './pages/Dashboard';
import { Logistics } from './pages/Logistics';
import { MedicalArchitecture } from './pages/MedicalArchitecture';
import { Medications } from './pages/Medications';
import { FamilyHistory } from './pages/FamilyHistory';
import { MedicalRecords } from './pages/MedicalRecords';
import { SignIn } from './pages/SignIn';
import { AccessDenied } from './pages/AccessDenied';
import { PortalDashboard } from './pages/portal/PortalDashboard';
import { PortalPlaceholder } from './pages/portal/PortalPlaceholder';
import './styles/main.css';

function App() {
  const profile = useMedplumProfile();
  const isPatient = profile?.resourceType === 'Patient';

  return (
    <BrowserRouter>
      {profile && isPatient && <SessionTimeoutGuard />}
      <Routes>
        {profile ? (
          isPatient ? (
            <>
              <Route path="/" element={<Navigate to="/dashboard" replace />} />

              {/* Portal routes — PortalLayout includes onboarding gate */}
              <Route element={<PortalLayout />}>
                <Route path="/dashboard" element={<PortalDashboard />} />
                <Route path="/results" element={<PortalPlaceholder routeId="results" />} />
                <Route path="/documents" element={<PortalPlaceholder routeId="documents" />} />
                <Route path="/medications" element={<PortalPlaceholder routeId="medications" />} />
                <Route path="/forms" element={<PortalPlaceholder routeId="forms" />} />
                <Route path="/insurance" element={<PortalPlaceholder routeId="insurance" />} />
              </Route>

              {/* Onboarding routes — always accessible */}
              <Route path="/onboarding" element={<Dashboard />} />
              <Route element={<SectionLayout />}>
                <Route path="/onboarding/medical-architecture" element={<MedicalArchitecture />} />
                <Route path="/onboarding/medications" element={<Medications />} />
                <Route path="/onboarding/matrix" element={<FamilyHistory />} />
                <Route path="/onboarding/logistics" element={<Logistics />} />
                <Route path="/onboarding/documents" element={<MedicalRecords />} />
              </Route>

              <Route path="/signin" element={<Navigate to="/dashboard" replace />} />
              <Route path="*" element={<Navigate to="/dashboard" replace />} />
            </>
          ) : (
            <>
              <Route path="*" element={<AccessDenied />} />
            </>
          )
        ) : (
          <>
            <Route path="/signin" element={<SignIn />} />
            <Route path="*" element={<Navigate to="/signin" replace />} />
          </>
        )}
      </Routes>
    </BrowserRouter>
  );
}

export default App;
